/*
 * Copyright (c) 2020, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
*/

import {FETCH_DOCUMENTS_REQUEST, FETCH_DOCUMENTS_SUCCESS, FETCH_DOCUMENTS_FAILURE, DocumentActions} from '../types/documents';

const initialState = {
    loading: true,
    documents: {},
    error: ''
}

const documentsReducer = (state = initialState, action: DocumentActions) => {
    switch(action.type) {
        case FETCH_DOCUMENTS_REQUEST:
            return {
                ...state,
                loading: true
            }
        case FETCH_DOCUMENTS_SUCCESS:
            return {
                ...state,
                loading: false,
                documents: action.payload,
                error: ''
            }
        case FETCH_DOCUMENTS_FAILURE:
            return {
                ...state,
                loading: true,
                documents: {},
                error: action.payload
            }
        default: return state
    }
}

export default documentsReducer;
